import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class DischargeSummaryService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private AddRecord = webapi + 'trn_discharge_summary/create';
  private ListbyRecord = webapi + 'trn_discharge_summary/admissionbyid/';

  constructor(
    private http: Http
  ) {
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getrecordservice(id: any) {
    return this.http.get(this.ListbyRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary/discharge-summary.service.ts